import { actions as modals } from './modals';

export type CheckRequestReviewAction = {
  type: 'REVIEWS/CHECK_REQUEST_REVIEW';
  pullRequestUUID: string;
};

export type RequestReviewAction = {
  type: 'REVIEWS/REQUEST_REVIEW';
  pullRequestUUID: string;
  h1ReportID?: number | null;
};

export const actions = {
  modals,
  checkRequestReview: (pullRequestUUID: string) => ({
    type: 'REVIEWS/CHECK_REQUEST_REVIEW',
    pullRequestUUID,
  }),
  requestReview: (pullRequestUUID: string, h1ReportID?: number | null) => ({
    type: 'REVIEWS/REQUEST_REVIEW',
    pullRequestUUID,
    h1ReportID,
  }),
};
